import moment from 'moment';
import { saveAs } from 'file-saver';
import { findIndex, forEach } from 'lodash';
import { dialCode, membershipType } from 'utils/constants';
import { decrypt, encrypt } from './index';
import { setApiError, storeUserCampaignLog, throwError } from 'store/slices';
import AWS from 'aws-sdk';
import { PDFDocument, rgb } from 'pdf-lib';
import axios from 'axios';
import { commonRoute } from '../constants/routes';
import { useState, useEffect } from 'react';
import { eventLogoPath } from '../constants';
const PDFJS = window.pdfjsLib;
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const s3 = new AWS.S3();

export function getHeaderData() {
  let header = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  if (getDataFromLocalStorage('token')) {
    header = {
      ...header,
      ...{ Authorization: `Bearer ${getDataFromLocalStorage('token')}` },
    };
  }
  return header;
}
export const storeLocalStorageData = (newData) => {
  const decryptData = decrypt(localStorage.userData || {});
  localStorage.userData = encrypt({ ...decryptData, ...newData });
};
export function getDataFromLocalStorage(key = '') {
  let returnValue = '';
  if (localStorage.userData) {
    const localObjectData = decrypt(localStorage.userData);
    if (key) {
      returnValue = localObjectData[key] ? localObjectData[key] : '';
    } else {
      returnValue = localObjectData;
    }
  }
  return returnValue;
}
// Adding data to local storage
export function addToLocalStorage(key = '', value = '') {
  value && localStorage.setItem(key, JSON?.stringify(value));
}
// Retrieving data from local storage
export function getFromLocalStorage(key = '') {
  const value = key && localStorage?.getItem(key);
  return value ? JSON.parse(value) : null;
}
// Removing data from local storage
export function removeFromLocalStorage(key) {
  key && localStorage.removeItem(key);
}
export function getDecryptValueFromResponse(
  encryptString,

  key = ''
) {
  let returnValue;
  // eslint-disable-next-line prefer-const
  returnValue = decrypt(encryptString);
  return returnValue;
}

export const getFilenameFromUrl = (url) => {
  if (Array.isArray(url)) {
    return url?.map((ul) => ul?.substring(ul?.lastIndexOf('/') + 1));
  } else {
    return url?.substring(url?.lastIndexOf('/') + 1);
  }
};

// export const getFilenameFromUrl = (url) => {
//   if (url) {
//     return url.substring(url.lastIndexOf("/") + 1);
//   }
//   return "";
// };

// convert string into title case
export const titleCaseString = (value) => {
  if (typeof value !== 'string') return '';
  return value.toLowerCase().replace(/\b(\w)/g, (s) => s.toUpperCase()); // Capital first character of each word
};
// Trim all left space
export const trimLeftSpace = (value) => value.replace(/^\s+/g, ''); // Remove white space from left side
// Trim all space
export const trimAllSpace = (value) => value.replace(/ /g, ''); // Remove white space from left side
export const customId = () => {
  return Math.random().toString(16).slice(2);
};
export const bytesToSize = (bytes) => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};
export const objectToFormData = (obj) => {
  let formData = new FormData();
  for (let key in obj) {
    formData.append(key, obj[key]);
  }
  return formData;
};

export const getFormDataArrayObject = (values) => {
  const formData = new FormData();
  Object.keys(values)?.forEach((key) => {
    if (Array.isArray(values[key])) {
      formData.append(key, JSON.stringify(values[key]));
    } else {
      formData.append(key, values[key]);
    }
  });
  return formData;
};

export const objectToQueryParams = (object) => {
  return new URLSearchParams(object).toString();
};

export const formatNumber = (format, number) => {
  const numberString = number.replace(/\D/g, '');
  var s = '' + numberString,
    r = '';
  for (var im = 0, is = 0; im < format.length && is < s.length; im++) {
    r += format.charAt(im) === 'X' ? s.charAt(is++) : format.charAt(im);
  }
  return r;
};
export const getStatus = (status, requestType) => {
  switch (`${status}`) {
    case '0' || 0:
      return 'Pending';
    case '1' || 1:
      return requestType === 'request' ? 'Approved' : 'Accepted';
    case '2' || 2:
      return 'Rejected';
    case '3' || 3:
      return 'In-Progress';
    case '4' || 4:
      return 'Published';
    default:
      return '';
  }
};

export const getStatusColor = (status) => {
  switch (`${status}`) {
    case '0' || 0:
      return 'color-5110';
    case '1' || 1:
      return 'color-a35b';
    case '2' || 2:
      return 'color-4646';

    default:
      return 'color-6866';
  }
};

export const getOtherStatus = (status) => {
  switch (`${status}`) {
    case '0' || 0:
      return 'Not Allocated';
    case '1' || 1:
      return 'Allocated';
    default:
      return '';
  }
};
export const formatDate = (date, format = 'DD MMM YYYY') => {
  let returnValue = '';
  if (date) {
    returnValue = moment(date).format(format);
  }
  return returnValue;
};
export const getEventDate = (start, end) => {
  let returnValue = '';
  if (start && end) {
    returnValue = formatDate(start);
    if (getDateProp('year', start) === getDateProp('year', end)) {
      if (getDateProp('month', start) === getDateProp('month', end)) {
        var days = getDaysDiff(start, end);
        if (days === 1) {
          returnValue = moment(start).format('DD MMM YYYY');
        } else if (days === 2) {
          returnValue = `${moment(start).format('DD')} & ${moment(end).format(
            'DD MMM YYYY'
          )}`;
        } else if (days > 2) {
          returnValue = `${moment(start).format('DD')} - ${moment(end).format(
            'DD MMM, YYYY'
          )}`;
        } else {
          returnValue = '';
        }
      } else {
        returnValue = `${moment(start).format('DD MMM')} - ${moment(end).format(
          'DD MMM, YYYY'
        )}`;
      }
    } else {
      returnValue = `${moment(start).format('DD MMM YYYY')} - ${moment(
        end
      ).format('DD MMM YYYY')}`;
    }
  }
  return returnValue;
};

export const formatSessionTime = (session_time, session_end_time) => {
  const start = moment(session_time, 'HH:mm:ss').format('h:mma');
  const end = session_end_time
    ? moment(session_end_time, 'HH:mm:ss').format('h:mma')
    : null;

  if (end) {
    return `${start} - ${end}`;
  } else {
    return start;
  }
};

export const getEventDateData = (start, end) => {
  let returnValue = {};
  if (start && end) {
    if (getDateProp('year', start) === getDateProp('year', end)) {
      if (getDateProp('month', start) === getDateProp('month', end)) {
        var days = getDaysDiff(start, end);
        if (days === 1) {
          returnValue = {
            display: moment(start).format('DD MMM'),
            year: moment(start).format('YYYY'),
          };
        } else if (days === 2) {
          returnValue = {
            display: `${moment(start).format('DD')} & ${moment(end).format(
              'DD'
            )}`,
            year: `${moment(end).format('MMM YYYY')}`,
          };
        } else if (days > 2) {
          returnValue = {
            display: `${moment(start).format('DD')} - ${moment(end).format(
              'DD,'
            )}`,
            year: `${moment(start).format('MMM YYYY')}`,
          };
        } else {
          returnValue = {};
        }
      } else {
        returnValue = {
          display: `${moment(start).format('DD')} - ${moment(end).format(
            'DD'
          )}`,
          year: `${moment(end).format('MMM YYYY')}`,
        };
      }
    } else {
      returnValue = {
        display: `${moment(start).format('DD MMM YYYY')} -`,
        year: `${moment(end).format('DD MMM YYYY')}`,
      };
    }
  }
  return returnValue;
};
export const getDaysDiff = (startDate, endDate, dateFormat = 'YYYY-MM-DD') => {
  const getDateAsArray = (date) => {
    return moment(date.split(/\D+/), dateFormat);
  };
  return getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days') + 1;
};
export const getDateProp = (type, date) => {
  let returnValue = '';
  const momentDate = moment(date);
  switch (type) {
    case 'year':
      returnValue = momentDate.format('YYYY');
      break;
    case 'month':
      returnValue = momentDate.format('MM');
      break;

    default:
      break;
  }
  return returnValue;
};
export const getEventStatus = (start, end) => {
  let returnValue = '';
  const startDate = moment(start);
  const endDate = moment(end);
  if (moment().isBetween(startDate, endDate)) {
    returnValue = 'On Going';
  } else if (moment().isSameOrBefore(startDate, endDate)) {
    returnValue = 'Completed';
  } else {
    returnValue = 'Upcoming';
  }

  return returnValue;
};
export const downloadFile =
  (url, name = null) =>
    async (dispatch) => {
      const fileName = name ? name : getFilenameFromUrl(url);
      if (fileName.includes('.')) {
        saveAs(url, fileName, { autoBom: false });
      } else {
        dispatch(
          setApiError({
            show: true,
            message: 'File extension is missing of this file.',
            type: 'danger',
          })
        );
      }
    };

export const convertOCMToType = (
  committeeMembersCategoryList,
  committeeMembers
) => {
  let newArr = committeeMembersCategoryList.map((i) => ({ ...i, data: [] }));
  forEach(committeeMembers, (elem) => {
    const index = findIndex(newArr, ['id', +elem?.committee_member_category]);
    if (index !== -1) {
      newArr[index].data.push(elem);
    }
  });
  return newArr;
};
export const userTypeByStatus = () => {
  let returnValue = 'member';
  switch (getDataFromLocalStorage('user_type')) {
    case '0':
      returnValue = 'admin';
      break;
    case '1':
      returnValue = 'super-admin';
      break;
    case '2':
      returnValue = 'professional';
      break;
    case '3':
      returnValue = 'institutional';
      break;
    case '4':
      returnValue = 'corporate';
      break;
    case '5':
      returnValue = 'student';
      break;
    case '6':
      returnValue = 'resource';
      break;
    case '7':
      returnValue = 'accounts';
      break;

    default:
      returnValue = 'member';
      break;
  }
  return returnValue;
};
// get string of message duration.
export const messageTime = (dateTime) => {
  let returnValue = '';
  const currentDate = moment();
  const fetchedDate = moment(dateTime, 'DD-MM-YYYY hh:mm A');
  const different = currentDate.diff(fetchedDate);
  const diffDuration = moment.duration(different);
  const days = diffDuration.days();
  const hours = diffDuration.hours();
  const minuts = diffDuration.minutes();
  if (fetchedDate) {
    if (days > 365) {
      const convertToYear = Math.floor(days / 365);
      returnValue = `${convertToYear} ${convertToYear === 1 ? 'year' : 'years'
        } ago`;
    } else if (days > 30) {
      const convertToMonth = Math.floor(days / 30);
      returnValue = `${convertToMonth} ${convertToMonth === 1 ? 'month' : 'months'
        } ago`;
    } else if (days > 7) {
      const convertToWeek = Math.floor(days / 7);
      returnValue = `${convertToWeek} ${convertToWeek === 1 ? 'week' : 'weeks'
        } ago`;
    } else if (days > 0) {
      returnValue = `${days} ${days === 1 ? 'day' : 'days'} ago`;
    } else if (hours > 0) {
      returnValue = `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    } else if (minuts > 0) {
      returnValue = `${minuts} ${minuts === 1 ? 'minute' : 'minutes'} ago`;
    } else if (minuts === 0) {
      return 'Just Now';
    } else {
      returnValue = '';
    }
  }

  return returnValue;
};


export const formattedDateTime = (date) => {
  const remarkDate = moment.utc(date).local();
  const today = moment().startOf("day");
  const remarkDay = remarkDate.clone().startOf("day");

  if (remarkDay.isSame(today, "day")) return `Today, ${remarkDate.format("hh:mm A")}`;
  if (remarkDay.isSame(moment().subtract(1, "day"), "day")) return `Yesterday, ${remarkDate.format("hh:mm A")}`;
  return remarkDate.format("DD-MM-YYYY, hh:mm A");
};

export const formatInboxTime = (date) => {
    const now = moment();
    const msgDate = moment(date, "DD-MM-YYYY hh:mm A");

    // Today?
    if (now.isSame(msgDate, "day")) {
        const diffMins = now.diff(msgDate, "minutes");

        if (diffMins < 1) return "Just Now";
        if (diffMins < 60) return `${diffMins} min ago`;

        return msgDate.format("hh:mm A"); // only time
    }

    // Older dates
    return msgDate.format("DD-MMM-YYYY, hh:mm A");
};

export const numberOnlyFromInput = (e) => {
  if (!e?.target?.id || !e?.target?.value) {
    return e; // Return the original event if id or value is missing
  }
  const id = e.target.id;
  const value = e.target.value;
  const newVal = value.replace(/[^0-9]/g, '');
  return {
    target: {
      id: id,
      value: newVal,
    },
  };
};
export const convertString = (type = 1, e) => {
  if (!e?.target?.id || !e?.target?.value) {
    return e; // Return the original event if id or value is missing
  }
  const id = e.target.id;
  const value = e.target.value;
  const strType = {
    1: value?.toLowerCase(),
    2: value?.toUpperCase(),
    3: titleCaseString(value),
  };
  const newVal = strType[type];
  return {
    target: {
      id: id,
      value: newVal,
    },
  };
};
export const getYearList = (num) => {
  return [...Array(num)].map((_, i) => {
    return { id: moment().subtract(i, 'year').format('YYYY') };
  });
};

export const getMonthAndYearList = () => {
  return [...Array(12)].map((_, i) => {
    return {
      id: `${moment().subtract(i, 'month').format('MM')}/${moment().format(
        'YYYY'
      )}`,
      value: `${moment().subtract(i, 'month').format('MMM')} ${moment().format(
        'YYYY'
      )}`,
    };
  });
};
export const getCountryCode = (val, optionKey = 'dial_code', key = 'code') => {
  let returnValue = dialCode.find((o) => o?.[key] === val)?.[optionKey] || '';
  return returnValue;
};

export const getOrderID = () => {
  return `${Math.floor(100000 + Math.random() * 900000)}`;
};
export const getYearByCount = (startYear, endYear) => {
  let returnValue = [];
  while (startYear <= endYear) {
    returnValue.push(`${startYear++}`);
  }
  return returnValue;
};

export const toURLEncoded = (obj, prefix) => {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + '[' + p + ']' : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? toURLEncoded(v, k)
          : encodeURIComponent(k) + '=' + encodeURIComponent(v)
      );
    }
  }
  return str.join('&');
};

export const getUserType = () => {
  const userType = getDataFromLocalStorage('user_type');
  let returnValue = 'member';
  if (userType) {
    returnValue = membershipType.find((o) => o.id === userType)?.type || '';
  }
  return returnValue;
};

export const generatePreSignedUrl = async (file, folderName) => {
  let returnValue = '';
  const url = await s3.getSignedUrlPromise('getObject', {
    Bucket: `${process.env.REACT_APP_AWS_BUCKET}/${folderName}`,
    Key: file,
    Expires: 3600,
  });
  returnValue = url;
  return returnValue;
};

export const combineArrayS3 = async (list, key, path) => {
  const promises = list?.map(async (elm) => {
    let response = elm[key] ? await generatePreSignedUrl(elm[key], path) : '';
    return { ...elm, s3File: response };
  });
  const results = await Promise.all(promises);
  return results;
};

export const convertDescription = (utfString, readMore = null, length) => {
  let returnValue = '';
  if (utfString) {
    let geturl = new RegExp(
      /(^|[ \t\r\n])((ftp|http|https|gopher|mailto|news|nntp|telnet|wais|file|prospero|aim|webcal):(([A-Za-z0-9$_.+!*(),;/?:@&~=-])|%[A-Fa-f0-9]{2}){2,}(#([a-zA-Z0-9][a-zA-Z0-9$_.+!*(),;/?:@&~=%-]*))?([A-Za-z0-9$_+!*();/?:~-]))/,
      'g'
    );
    let text = utfString?.replace(/\n\r?/g, '<br />');
    if (text?.length > 100 && readMore) {
      text =
        text?.substring(0, length ? length : 100) +
        `... <a href="${readMore}">Read more</a>`;
    }
    let matchData = text.match(geturl);
    matchData?.forEach((e) => {
      text = text?.replace(
        e,
        ` <a className="" href="${trimLeftSpace(
          e
        )}" target="_blank">${trimLeftSpace(e)}</a>`
      );
    });
    returnValue = text;
  }
  return returnValue;
};

export const extractPDFData = async (pdfUrl) => {
  var pdfData = await PDFJS.getDocument({
    url: pdfUrl,
    'Access-Control-Allow-Origin': '*',
  });
  const imagesList = [];
  const canvas = document.createElement('canvas');
  canvas.setAttribute('className', 'canv');
  let textString = '';
  for (let i = 1; i <= pdfData.numPages; i++) {
    var page = await pdfData.getPage(i);
    const text = await page.getTextContent();
    var items = text.items;
    var finalString = '';
    var line = 0;

    for (var t = 0; t < items.length; t++) {
      if (line !== items[t].transform[5]) {
        if (line !== 0) {
          finalString += '\r\n';
        }
        line = items[t].transform[5];
      }
      finalString += items[t].str;
    }
    textString += finalString;

    var viewport = page.getViewport({ scale: 2 });
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    var render_context = {
      canvasContext: canvas.getContext('2d'),
      viewport: viewport,
    };

    await page.render(render_context).promise;
    let img = canvas.toDataURL('image/png');
    imagesList.push(img);
  }

  return {
    content: textString,
    pages: imagesList,
  };
};

// convert file to base64
export const getBase64 = async (file) => {
  let returnValue = '';
  let reader = new FileReader();
  reader.readAsDataURL(file);
  await new Promise(async (resolve, reject) => {
    reader.onload = () => {
      returnValue = reader.result;
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
  return returnValue;
};

// convert base64/url to Uint8Array
export const urlToUnitArray = async (url) => {
  let retunData = [];
  await fetch(url)
    .then((res) => res.arrayBuffer())
    .then((buffer) => {
      retunData = new Uint8Array(buffer);
    });
  return retunData;
};

//convert blob to file
// export const convertBlobToFile = (blobUrl, fileName, mimeType) => {
//   const type = { type: mimeType };
//   const blobWithMimeType = new Blob([blobUrl], type);
//   return new File([blobWithMimeType], fileName, type);
// };

// convert hexa color to rgb
export const hexToRgbA = (hex) => {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return [(c >> 16) & 255, (c >> 8) & 255, c & 255];
  }
  throw new Error('Bad Hex');
};

// convert Uint8Array to base64
export const bytesToBase64 = (bytes) => {
  const base64abc = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '+',
    '/',
  ];
  let result = '',
    i,
    l = bytes.length;
  for (i = 2; i < l; i += 3) {
    result += base64abc[bytes[i - 2] >> 2];
    result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
    result += base64abc[((bytes[i - 1] & 0x0f) << 2) | (bytes[i] >> 6)];
    result += base64abc[bytes[i] & 0x3f];
  }
  if (i === l + 1) {
    // 1 octet yet to write
    result += base64abc[bytes[i - 2] >> 2];
    result += base64abc[(bytes[i - 2] & 0x03) << 4];
    result += '==';
  }
  if (i === l) {
    // 2 octets yet to write
    result += base64abc[bytes[i - 2] >> 2];
    result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
    result += base64abc[(bytes[i - 1] & 0x0f) << 2];
    result += '=';
  }
  return result;
};

export const getCertificateData = (jsonData, exData = []) => {
  let data = jsonData ? JSON.parse(jsonData) : [];
  const userData = getDataFromLocalStorage();
  const {
    first_name,
    last_name,
    membership_details,
    user_type,
    member_id,
    personal_details = {},
    educational_details = {},
    professional_details = {},
    institution_details = {},
    company_details = {},
  } = userData;

  let { ug_institution_name, pg_institution_name, phd_institution_name } =
    educational_details;
  const { country_name } = personal_details;
  const {
    country_name: professionalCountry,
    institution_name: professionalInstitutionName,
  } = professional_details;
  const { institution_name, country_name: institutionCountry } =
    institution_details;
  const { company_name, company_country_name } = company_details;
  let countryName =
    country_name ||
    professionalCountry ||
    institutionCountry ||
    company_country_name ||
    '';
  let instituteValue =
    phd_institution_name ||
    pg_institution_name ||
    ug_institution_name ||
    institution_name ||
    company_name;
  if (user_type === '2') {
    instituteValue = professionalInstitutionName;
  }
  const findType = membershipType.find((o) => o.id === user_type)?.type;
  const dataObj = {
    user_name: `${first_name} ${last_name}`,
    first_name: first_name,
    last_name: last_name,
    start_date: moment(membership_details?.start_date).format('DD/MM/YYYY'),
    expire_date: moment(membership_details?.expire_date).format('DD/MM/YYYY'),
    membership_id: member_id,
    member_type: titleCaseString(findType),
    nationality: countryName,
    institution_or_company: instituteValue,
    cert_no: exData?.certificate_number || '',
    paper_title: exData?.paper_title || '',
    date_of_issue: exData?.create_at
      ? moment(exData?.create_at).format('DD/MM/YYYY')
      : '',
  };
  return data.map((elm) => {
    return { ...elm, value: dataObj?.[elm?.fieldName] || '' };
  });
};

export const getCertificatePdf = async (pdfFileData, fieldData) => {
  const pdfDoc = await PDFDocument.load(pdfFileData);
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { height } = firstPage?.getSize();

  fieldData?.forEach((elm) => {
    const {
      value,
      left,
      top,
      fontSize,
      fontColor,
      lineBreak,
      wordLeft,
      wordTop,
      isCenter,
    } = elm;
    const canvas = document.getElementById('textCanvas');
    const context = canvas.getContext('2d');
    context.font = `${fontSize}px`;
    const textWidth = context.measureText(value).width;
    const centerX = left - textWidth / 2;
    let nC = hexToRgbA(fontColor);
    if (lineBreak) {
      if (value) {
        const sapratorChar = value?.substring(
          parseInt(lineBreak) - 1,
          parseInt(lineBreak)
        );
        const line1 = `${value?.substring(0, parseInt(lineBreak))}${sapratorChar !== ' ' && sapratorChar ? '-' : ''
          }`;
        const line2 = value?.substring(parseInt(lineBreak));
        firstPage.drawText(line1, {
          x: +left,
          y: height - +top,
          size: +fontSize,
          color: rgb(nC[0] / 255, nC[1] / 255, nC[2] / 255),
        });
        firstPage.drawText(line2, {
          x: +wordLeft,
          y: height - +wordTop,
          size: +fontSize,
          color: rgb(nC[0] / 255, nC[1] / 255, nC[2] / 255),
        });
      }
    } else {
      if (value) {
        firstPage.drawText(value, {
          // x: +left,
          x: isCenter ? centerX : +left,
          y: height - +top,
          size: +fontSize,
          color: rgb(nC[0] / 255, nC[1] / 255, nC[2] / 255),
        });
      }
    }
  });
  const pdfBytes = await pdfDoc.save();
  return pdfBytes;
};

export const calculateRows = (text) => {
  return Math.max(text?.split('\n')?.length, 3);
};

export const convertCurrency = (amount, exchangeRate, isNational) => {
  let convertedAmount = '';
  if (isNational) {
    convertedAmount = amount * exchangeRate; // Convert from USD to INR
    return formatCurrency(convertedAmount, 'en-IN', 'INR');
  } else {
    convertedAmount = amount / exchangeRate; // Convert from INR to USD
    return formatCurrency(convertedAmount, 'en-US', 'USD');
  }
};

export const formatCurrency = (number, locale, currency) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  });
  return formatter.format(number);
};

export const USDtoINR = (amount, exchangeRate) => {
  let price = '';
  if (amount) {
    price = amount * exchangeRate;
    return price;
  }
};
export const INRtoUSD = (amount, exchangeRate) => {
  let price = '';
  if (amount) {
    price = amount / exchangeRate;
    return price;
  }
  return 0;
};
export const dashConvertedString = (str) => {
  return str
    ?.replace(/ *\([^)]*\) *|\.$/g, '') // Remove bracketed parts and trailing dots
    ?.trim()
    ?.toLowerCase()
    .replace(/\s+/g, '-');
};

export const stringWithSpecialCharacter = (str) => {
  return str
    ?.replace(/ *\([^)]*\) *|\.$/g, '') // Remove bracketed parts and trailing dots
    ?.trim()
    ?.toLowerCase();
};

export const formatSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const paddedMinutes = String(minutes).padStart(2, '0');
  const paddedSeconds = String(remainingSeconds).padStart(2, '0');
  return `${paddedMinutes}:${paddedSeconds}`;
};

export const formatCount = (count) => {
  if (count >= 1000000000) {
    return (count / 1000000000).toFixed(1) + 'b';
  } else if (count >= 1000000) {
    return (count / 1000000).toFixed(1) + 'm';
  } else if (count >= 1000) {
    return (count / 1000).toFixed(1) + 'k';
  } else {
    return count.toString();
  }
};

export function findOverallMax(data, defaultValue = 0) {
  return data?.reduce((max, item) => {
    if (item?.data?.length > 0) {
      const maxInArray = Math.max(...item?.data);
      return maxInArray > max ? maxInArray : max;
    }
    return max;
  }, defaultValue);
}

export const getPhoneNumberLength = (country_code = 'IN') => {
  const newLength = dialCode?.filter((list) => list?.code === country_code);
  return newLength ? newLength?.[0]?.phoneLength : 10;
};

export const replaceFileName = (originalName, newName) => {
  if (typeof originalName !== 'string' || !originalName) {
    return newName;
  }

  const parts = originalName?.split(/-(.+)/);
  const extension = parts[1]?.split('.')?.pop();
  const newFileName = `${newName}.${extension}`;

  return newFileName;
};

// store log API for campaign
export const handleCampaignLog = (payload, dispatch) => {
  dispatch(storeUserCampaignLog(objectToFormData(payload)));
};

export const navigateIfCampaign = (navigate, userType = '') => {
  if (localStorage.getItem('IsNavigateProfile')) {
    navigate(`/${userType}/my-details`);
    localStorage.removeItem('IsNavigateProfile');
  }
};

//file size type
export const formatFileSize = (sizeInBytes) => {
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  let index = 0;
  let size = sizeInBytes;

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }

  return `${size.toFixed(2)} ${units[index]}`;
};

// export const getStatusColor = (value) => {
//   if (value) {
//     if (value === '1') {
//       return 'color-a35b';
//     } else if (value === '0') {
//       return 'color-5110';
//     } else if (value === '2') {
//       return 'color-7cff';
//     } else {
//       return 'color-6866';
//     }
//   }
// };

export const getEmailSubject = (value) => {
  if (value?.followUps) {
    switch (value?.followUps) {
      case 'Session name inclusion notification':
        return `Session Details for ${value?.conference_short_name} | Presenting ${value?.paper_title}`;
      case 'Coupon or Voucher follow ups':
        return `🎟️ Your Exclusive Discount for ${value?.conference_short_name} Expires Soon!`;
      case 'Coupon or Voucher follow ups/early bird deadline':
        return `🎟️ Your Exclusive Discount for ${value?.conference_short_name} Expires Soon!`;
      case 'Publication Details Few slots left':
        return `Enhance Your Research Paper ${value?.paper_title} Visibility: ISBN and ISSN Now Available for ${value?.conference_name}`;
      case 'Session-Based Publication Opportunities and Conference Outcomes at [Conference Name]':
        return `Session-Based Publication Opportunities and Conference Outcomes at ${value?.conference_name}`;
      case 'Keynote speaker, session speaker notification':
        return `Meet Our Esteemed Speakers at the Upcoming Conference!`;
      case 'Agenda Page and Slot Allotment notification':
        return `Final Agenda & Slot Allotment for  ${value?.conference_short_name} - Your Participation Details`;
      case 'Hall Ticket, Zoom link and Confirmation':
        return `Final Agenda and Venue Information for ${value?.conference_name}`;
      case 'Full Paper Follow-Up Email':
        return `Follow-Up: Full Paper Submission of ${value?.paper_title}`;
      case 'Conference testimonials email with CPD':
        return `🌟 ${value?.conference_short_name} – Hear What Attendees Are Saying! 🌟`;
      case 'Scope of the Research Notification':
        return `Present Your Research at ${value?.conference_short_name} – CPD Accredited!`;
      case 'Coupon or Voucher follow ups/early bird deadline - Set 2':
        return `🎉 Exclusive Discount: Register for ${value?.conference_name} Now!`;
      case 'Coupon or Voucher follow ups/early bird deadline - Set 3':
        return `⏳ Last Chance to Claim Your Early Bird Voucher!`;
      case 'Allotment of ISBN and ISSN Number':
        return `Enhance Your Research Paper ${value?.paper_title} Visibility: ISBN and ISSN Now Available for ${value?.conference_short_name}`;
      case 'Visa-Free Projection':
        return `Visa-Free Projection`;
      case 'Scholarships & Awards Notification':
        return `Scholarships & Awards Notification`;
      case 'Pre-Conference Webinar Announcement':
        return `Pre-Conference Webinar Announcement`;
      case 'Refer Your Colleagues':
        return `Invite Your Colleagues & Enjoy Exclusive Discounts at ${value?.conference_short_name}!`;
      case 'Awards sales Follow up':
        return `Submit Your Research for ${value?.conference_short_name} Awards - Recognition Awaits!`;
      case 'Proceedings book Sales Follow up':
        return `Last Chance to Be Included in the ${value?.conference_short_name} Proceedings Book!`;
      case 'Agenda Sales Follow up':
        return `Final Call to Join ${value?.conference_short_name} – Register Now!`;
      case 'Final Thank You Email for unregistered participants':
        return `Thank You for Your Interest – Stay Connected for Future Events!`;

      default:
        return '';
    }
  }
};

export const helpDeskMailIFERP = 'helpdesk@iferp.in';

export const getCountryCodeName = (val, key = 'code') => {
  let returnValue = dialCode.find((o) => o?.[key] === val)?.[key] || '';
  return returnValue;
};

export const fetchFileSize = async (file) => {
  try {
    const response = await axios.get(file, { responseType: 'blob' });
    const size = response?.data?.size;

    if (size) {
      const formattedSize = formatFileSize(size);
      return { rawSize: size, formattedSize };
    }
  } catch (error) {
    return { rawSize: 0, formattedSize: 'Failed to fetch size' };
  }
};

// access permission for admin, resource role and accounts
const userData = getDataFromLocalStorage();
export const accessPermission = userData?.role_data ? userData?.role_data : [];

// mask email and mobile
export const maskUtils = {
  maskEmail: (email) => {
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      return 'Invalid email';
    }
    const [username, domain] = email?.split('@');
    return `${username[0]}***@${domain}`;
  },

  maskPhone: (phone) => {
    if (!phone) return 'No phone number provided';

    // Clean the phone number (remove non-numeric characters)
    const numericPhone = phone?.replace(/\D/g, '');
    if (numericPhone?.length < 4) return 'Invalid phone number';

    // Always show the first 3 and last 3 digits, mask the rest
    const start = numericPhone?.slice(0, 3); // First 3 digits
    const end = numericPhone?.slice(-3); // Last 3 digits
    const maskedPart = '*'.repeat(numericPhone?.length - 6); // Mask the middle digits

    return `${start}${maskedPart}${end}`;
  },
};

export const paymentColor = (values = '') => {
  if (values) {
    const lowerCaseValue = values.toLowerCase();
    if (lowerCaseValue.includes('unpaid')) {
      return 'color-E751 text-14-400';
    } else if (lowerCaseValue.includes('under verification')) {
      return 'color-C991 text-14-400';
    } else if (lowerCaseValue.includes('paid')) {
      return 'color-a35b text-14-400';
    } else if (lowerCaseValue.includes('pending')) {
      return 'color-a500 text-14-400';
    } else if (lowerCaseValue.includes('downloaded')) {
      return 'color-a35b text-14-400';
    } else if (lowerCaseValue.includes('present')) {
      return 'color-a35b text-14-400';
    } else if (lowerCaseValue.includes('approved')) {
      return 'color-a35b text-14-400';
    } else if (lowerCaseValue.includes('rejected')) {
      return 'color-red text-14-400';
    } else if (lowerCaseValue.includes('publish')) {
      return 'color-new-car text-14-400';
    } else if (lowerCaseValue.includes('completed')) {
      return 'color-a35b text-14-400';
    }
  }
  return 'color-black';
};

export const handleFileDownload = async (
  e,
  fileName,
  filePath,
  action = 'download'
) => {
  e.preventDefault();
  if (!fileName) return;
  try {
    const url = await generatePreSignedUrl(fileName, filePath);
    if (action === 'view') {
      window.open(url, '_blank');
      return;
    }
    const response = await axios.get(url, { responseType: 'blob' });
    const mimeType = response.data.type;
    const blob = new Blob([response.data], { type: mimeType });
    saveAs(blob, fileName);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const handleViewPreview = async (previewFile, eventAbstarctPath) => {
  if (previewFile) {
    const res = await generatePreSignedUrl(previewFile, eventAbstarctPath);
    const fileEx = previewFile?.split('.')?.pop()?.toLowerCase();

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

    if (fileEx === 'pdf') {
      window.open(res, '_blank'); // PDF: open directly
    } else if (imageExtensions.includes(fileEx)) {
      window.open(res, '_blank'); // Image: open directly
    } else {
      // Other types like DOC, PPT, XLS: open via Google Docs Viewer
      const googleDocsUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
        res
      )}&embedded=true`;
      window.open(googleDocsUrl, '_blank');
    }
  }
};

export const formatTime = (s) => {
  const minutes = Math.floor(s / 60);
  const seconds = s % 60;

  const minStr = minutes.toString().padStart(2, "0");
  const secStr = seconds.toString().padStart(2, "0");

  return `${minStr}:${secStr}`;
};


export const VERIFICATION_STEPS = {
  EMAIL_ONLY: ['email_verification_status'],

  PROFILE_ONLY: [
    'education_details_status',
    'professional_details_status',
    'email_verification_status',
  ],

  FULL_PROFILE: [
    'education_details_status',
    'professional_details_status',
    'certificate_details_status',
    'email_verification_status',
  ],
};

export const checkEmailVerification = (
  dispatch,
  navigate,
  verificationSteps = ['email_verification_status']
) => {
  const isEmailOnly =
    verificationSteps.length === 1 &&
    verificationSteps[0] === 'email_verification_status';

  const userStatus = getDataFromLocalStorage('user_updation_status');
  const userType = getDataFromLocalStorage('user_type');
  const memberType = getUserType();

  if (userType !== '2' && userType !== '5') {
    return true; // Skip verification for others
  }

  const statusChecks = {
    email_verification_status: {
      expected: '1',
      label: 'Verify Email',
    },
    education_details_status: {
      expected: '1',
      label: 'Update Educational Information',
    },
    professional_details_status: {
      expected: '1',
      label: 'Professional Details (if applicable)',
      skipForUserType: '5', // skip for user_type = '5'
    },
    certificate_details_status: {
      expected: '1',
      label: 'Certificate Details',
    },
  };

  const failedLabels = [];

  for (let step of verificationSteps) {
    const check = statusChecks[step];
    if (!check) continue;

    if (check.skipForUserType && userType === check.skipForUserType) {
      continue;
    }

    const value = userStatus?.[step];
    if (value !== check.expected) {
      failedLabels.push(check.label);
    }
  }

  if (failedLabels.length > 0) {
    let message = '';

    if (
      isEmailOnly &&
      failedLabels.length === 1 &&
      failedLabels.includes('Verify Email')
    ) {
      message = 'Please verify your Email ID via link or OTP.';
      navigate(`/${memberType}/verify-email`);
    } else {
      message = `Please complete the following: ${failedLabels.join(', ')}`;
      navigate(`/${memberType}/complete-profile`);
    }

    dispatch(throwError({ message }));

    return false;
  }

  return true;
};


export const EventLogoPreview = ({ logoValue }) => {
  const [imageUrl, setImageUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const generateUrl = async () => {
      setIsLoading(true);
      if (logoValue) {
        if (logoValue.startsWith('data:')) {
          // It's a base64 string, use it directly
          setImageUrl(logoValue);
          setIsLoading(false);
        } else {
          // It's a path, generate pre-signed URL using logoValue (the path)
          try {
            const url = await generatePreSignedUrl(logoValue, eventLogoPath);
            setImageUrl(url);
          } catch (error) {
            console.error('Error generating pre-signed URL:', error);
            setImageUrl(logoValue || '');
          } finally {
            setIsLoading(false);
          }
        }
      } else {
        setImageUrl('');
        setIsLoading(false);
      }
    };

    generateUrl();
  }, [logoValue]);

  if (isLoading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!imageUrl) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>No image available</div>
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt="Event Logo"
      style={{
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
      }}
      onError={(e) => {
        e.target.src = logoValue || '';
      }}
    />
  );
};